import Rong from '../api/rong'
import store from './index'
import Tool from '../assets/commonjs/tool'



const state = {
  title: 'rong',
  conversationlist: [], //会话列表
  historyContent: [], //历史记录
  // groupContent:[],//群历史记录
  total: null, //记录总条数
  // grouptotal:'',//群记录总条数
  singleHeadUrl: [], //单人会话头像
  groupHeadUrl: [], //群会话头像
  historyPage: [], //记录页码
  maxpasge: 0, //记录最大页码
  DATE: null,
  nomessage: true, 
  recvID: '',
  startTime: 0,
  endTime: new Date().getTime(),
  downtype: '',
  initnum: null,
  searchList: [],
  activeIndex: null,
  activeGroupIndex: null,
  day1:'',
  day2:'',
  currentPage:1,
  downfinish:false,
  timeShow:false
}

const getters = {

  personalList() {
    if (state.conversationlist)
      // let list = JSON.parse(JSON.stringify(state.conversationlist))
      return state.conversationlist.filter((item) => {
        return item.recvType == "PERSON";
      })
  },
  groupList() {
    // let list = JSON.parse(JSON.stringify(state.conversationlist))
    if (state.conversationlist)
      return state.conversationlist.filter((item) => {
        return item.recvType == "GROUP";
      })
  },
  contentlist() {
    let list = state.historyContent.reverse()
    
    let nowDate = 0
    list.map(item => {
      if (item.sendTime) {
        let showTime = Tool.timeNum(Tool.timeString(item.sendTime), 'yyyy-MM-dd')
        if (showTime !== nowDate) {
          item['showTime'] = showTime
          nowDate = showTime
        }
        // console.log(Tool.timeString(item.sendTime))
        
        item.sendTime = Tool.timeNum(Tool.timeString(item.sendTime), 'hh:mm')
      }
      
      // console.log(item.sendTime)
      return item
    })
    return list 
  },

}

const mutations = {
  async getPersonList(state, params) {
    state.conversationlist = await Rong.getPersonList(params)
    // console.log(state.conversationlist)
  },
  async showHistory_s_r(state, params) {
    state.historyContent = []
    state.historyPage = []
    let data = await Rong.show_history(params)
    state.historyContent = data.data
    state.total = parseInt(data.data[0].total)

    state.maxpasge = Math.ceil(data.data[0].total / 50);
    // let list = []
    // for (let i = 0; i < state.maxpasge; i++)
    //   list[i] = i + 1;
    // state.historyPage = list
    // console.log(state.historyPage, state.maxpasge)
    // console.log(state.historyContent)
    // state.historyPage = Tool.drawPage(state.maxpasge, 12, 1)
  },
  async showHistory_g_r(state, params) {
    state.historyPage = []
    state.historyContent = []
    let data = await Rong.group_history(params)
    state.historyContent = data.data
    // console.log(state.historyContent)
    state.total = parseInt(data.data[0].total)
    state.maxpasge = Math.ceil(data.data[0].total / 50);
    // let list = []
    // for (let i = 0; i < state.maxpasge; i++)
    //   list[i] = i + 1;

    // console.log(state.historyContent)
    // state.historyPage = Tool.drawPage(state.maxpasge, 12, 1)
  },
  async download_s_Ry(state, params) {
    let s = null;
    let data = await Rong.download_s_Ry(params)
    // console.log(data.success)
    state.downfinish = true;
    s = setTimeout(()=>{
      state.downfinish = false;
    },2000)
    window.location.href = data.data
  },
  async download_g_Ry(state, params) {
    let s = null;
    let data = await Rong.download_g_Ry(params)
    state.downfinish = true;
    s = setTimeout(()=>{
      state.downfinish = false;
    },2000)
    window.location.href = data.data
  },

  showSearchList(state, params) {
    let list = []
    list = JSON.parse(JSON.stringify(state.conversationlist)).filter(item => {
      if (item.recvType == "GROUP")
        return item.name.includes(params)
      if (item.recvType == "PERSON")
        return item.recvId.includes(params)
    })
    state.searchList = list

  },

  getSingleHeadUrl(state, params) {
    state.singleHeadUrl = params
    // console.log(state.singleHeadUrl)
  },
  getGroupHeadUrl(state, params) {
    state.groupHeadUrl = params
    // console.log(state.groupHeadUrl)
  },
  getrecvID(state, params) {
    state.recvID = params
  },
  getType(state, params) {
    state.downtype = params
  },

  //动态添加类名

  activeNum(state, params) {
    state.activeIndex = params
  },

  activeGroup(state, params) {
    state.activeGroupIndex = params
  },
  initNum(state) {
    state.initnum = 1
  },

  getStart(state, params) {
    state.startTime = params
    // console.log(state.startTime)
  },
  getEnd(state, params) {
    state.endTime = params
    // console.log(state.endTime)
  },

  compareTime(state){
    let timeout = null;
    if (state.day2 < state.day1 && state.day2 != "") {
      state.timeShow = true;
    }
    timeout = setTimeout(()=>{
      state.timeShow = false;
    },2000)
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/rong.js